/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArticleCategoryWithIdDto } from '../models/article-category-with-id-dto';
import { ArticleWithIdDto } from '../models/article-with-id-dto';
import { ProfileDto } from '../models/profile-dto';
import { shopCreateOrder } from '../fn/shop/shop-create-order';
import { ShopCreateOrder$Params } from '../fn/shop/shop-create-order';
import { shopDeleteArticle } from '../fn/shop/shop-delete-article';
import { ShopDeleteArticle$Params } from '../fn/shop/shop-delete-article';
import { shopDeleteArticleCategory } from '../fn/shop/shop-delete-article-category';
import { ShopDeleteArticleCategory$Params } from '../fn/shop/shop-delete-article-category';
import { shopGetArticles } from '../fn/shop/shop-get-articles';
import { ShopGetArticles$Params } from '../fn/shop/shop-get-articles';
import { shopGetCategories } from '../fn/shop/shop-get-categories';
import { ShopGetCategories$Params } from '../fn/shop/shop-get-categories';
import { shopGetShopOrders } from '../fn/shop/shop-get-shop-orders';
import { ShopGetShopOrders$Params } from '../fn/shop/shop-get-shop-orders';
import { shopGetShopProfile } from '../fn/shop/shop-get-shop-profile';
import { ShopGetShopProfile$Params } from '../fn/shop/shop-get-shop-profile';
import { shopInsertArticle } from '../fn/shop/shop-insert-article';
import { ShopInsertArticle$Params } from '../fn/shop/shop-insert-article';
import { shopInsertArticleCategory } from '../fn/shop/shop-insert-article-category';
import { ShopInsertArticleCategory$Params } from '../fn/shop/shop-insert-article-category';
import { ShopOrderDto } from '../models/shop-order-dto';
import { shopUpdateArticle } from '../fn/shop/shop-update-article';
import { ShopUpdateArticle$Params } from '../fn/shop/shop-update-article';
import { shopUpdateArticleCategory } from '../fn/shop/shop-update-article-category';
import { ShopUpdateArticleCategory$Params } from '../fn/shop/shop-update-article-category';
import { shopUpdateOrder } from '../fn/shop/shop-update-order';
import { ShopUpdateOrder$Params } from '../fn/shop/shop-update-order';
import { shopUpdateShopProfile } from '../fn/shop/shop-update-shop-profile';
import { ShopUpdateShopProfile$Params } from '../fn/shop/shop-update-shop-profile';

@Injectable({ providedIn: 'root' })
export class ShopApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopGetArticles()` */
  static readonly ShopGetArticlesPath = '/api/shop/articles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopGetArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopGetArticles$Response(params?: ShopGetArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticleWithIdDto>>> {
    const obs = shopGetArticles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopGetArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopGetArticles(params?: ShopGetArticles$Params, context?: HttpContext): Observable<Array<ArticleWithIdDto>> {
    const resp = this.shopGetArticles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ArticleWithIdDto>>): Array<ArticleWithIdDto> => r.body)
    );
  }

  /** Path part for operation `shopGetCategories()` */
  static readonly ShopGetCategoriesPath = '/api/shop/categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopGetCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopGetCategories$Response(params?: ShopGetCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticleCategoryWithIdDto>>> {
    const obs = shopGetCategories(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopGetCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopGetCategories(params?: ShopGetCategories$Params, context?: HttpContext): Observable<Array<ArticleCategoryWithIdDto>> {
    const resp = this.shopGetCategories$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ArticleCategoryWithIdDto>>): Array<ArticleCategoryWithIdDto> => r.body)
    );
  }

  /** Path part for operation `shopUpdateArticle()` */
  static readonly ShopUpdateArticlePath = '/api/shop/article/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopUpdateArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateArticle$Response(params: ShopUpdateArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleWithIdDto>> {
    const obs = shopUpdateArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopUpdateArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateArticle(params: ShopUpdateArticle$Params, context?: HttpContext): Observable<ArticleWithIdDto> {
    const resp = this.shopUpdateArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleWithIdDto>): ArticleWithIdDto => r.body)
    );
  }

  /** Path part for operation `shopDeleteArticle()` */
  static readonly ShopDeleteArticlePath = '/api/shop/article/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopDeleteArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopDeleteArticle$Response(params: ShopDeleteArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = shopDeleteArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopDeleteArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopDeleteArticle(params: ShopDeleteArticle$Params, context?: HttpContext): Observable<void> {
    const resp = this.shopDeleteArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `shopInsertArticle()` */
  static readonly ShopInsertArticlePath = '/api/shop/article';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopInsertArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopInsertArticle$Response(params: ShopInsertArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleWithIdDto>> {
    const obs = shopInsertArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopInsertArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopInsertArticle(params: ShopInsertArticle$Params, context?: HttpContext): Observable<ArticleWithIdDto> {
    const resp = this.shopInsertArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleWithIdDto>): ArticleWithIdDto => r.body)
    );
  }

  /** Path part for operation `shopUpdateArticleCategory()` */
  static readonly ShopUpdateArticleCategoryPath = '/api/shop/category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopUpdateArticleCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateArticleCategory$Response(params: ShopUpdateArticleCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleCategoryWithIdDto>> {
    const obs = shopUpdateArticleCategory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopUpdateArticleCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateArticleCategory(params: ShopUpdateArticleCategory$Params, context?: HttpContext): Observable<ArticleCategoryWithIdDto> {
    const resp = this.shopUpdateArticleCategory$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleCategoryWithIdDto>): ArticleCategoryWithIdDto => r.body)
    );
  }

  /** Path part for operation `shopDeleteArticleCategory()` */
  static readonly ShopDeleteArticleCategoryPath = '/api/shop/category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopDeleteArticleCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopDeleteArticleCategory$Response(params: ShopDeleteArticleCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = shopDeleteArticleCategory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopDeleteArticleCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopDeleteArticleCategory(params: ShopDeleteArticleCategory$Params, context?: HttpContext): Observable<void> {
    const resp = this.shopDeleteArticleCategory$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `shopInsertArticleCategory()` */
  static readonly ShopInsertArticleCategoryPath = '/api/shop/category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopInsertArticleCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopInsertArticleCategory$Response(params: ShopInsertArticleCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleCategoryWithIdDto>> {
    const obs = shopInsertArticleCategory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopInsertArticleCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopInsertArticleCategory(params: ShopInsertArticleCategory$Params, context?: HttpContext): Observable<ArticleCategoryWithIdDto> {
    const resp = this.shopInsertArticleCategory$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleCategoryWithIdDto>): ArticleCategoryWithIdDto => r.body)
    );
  }

  /** Path part for operation `shopUpdateOrder()` */
  static readonly ShopUpdateOrderPath = '/api/shop/order/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopUpdateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateOrder$Response(params: ShopUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
    const obs = shopUpdateOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopUpdateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateOrder(params: ShopUpdateOrder$Params, context?: HttpContext): Observable<ShopOrderDto> {
    const resp = this.shopUpdateOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDto>): ShopOrderDto => r.body)
    );
  }

  /** Path part for operation `shopCreateOrder()` */
  static readonly ShopCreateOrderPath = '/api/shop/order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopCreateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopCreateOrder$Response(params: ShopCreateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
    const obs = shopCreateOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopCreateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopCreateOrder(params: ShopCreateOrder$Params, context?: HttpContext): Observable<ShopOrderDto> {
    const resp = this.shopCreateOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDto>): ShopOrderDto => r.body)
    );
  }

  /** Path part for operation `shopGetShopOrders()` */
  static readonly ShopGetShopOrdersPath = '/api/shop/shop-orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopGetShopOrders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopGetShopOrders$Response(params: ShopGetShopOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShopOrderDto>>> {
    const obs = shopGetShopOrders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopGetShopOrders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopGetShopOrders(params: ShopGetShopOrders$Params, context?: HttpContext): Observable<Array<ShopOrderDto>> {
    const resp = this.shopGetShopOrders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ShopOrderDto>>): Array<ShopOrderDto> => r.body)
    );
  }

  /** Path part for operation `shopGetShopProfile()` */
  static readonly ShopGetShopProfilePath = '/api/shop/profile/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopGetShopProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopGetShopProfile$Response(params: ShopGetShopProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileDto>> {
    const obs = shopGetShopProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopGetShopProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopGetShopProfile(params: ShopGetShopProfile$Params, context?: HttpContext): Observable<ProfileDto> {
    const resp = this.shopGetShopProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProfileDto>): ProfileDto => r.body)
    );
  }

  /** Path part for operation `shopUpdateShopProfile()` */
  static readonly ShopUpdateShopProfilePath = '/api/shop/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopUpdateShopProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateShopProfile$Response(params: ShopUpdateShopProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileDto>> {
    const obs = shopUpdateShopProfile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopUpdateShopProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopUpdateShopProfile(params: ShopUpdateShopProfile$Params, context?: HttpContext): Observable<ProfileDto> {
    const resp = this.shopUpdateShopProfile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProfileDto>): ProfileDto => r.body)
    );
  }

}
